import script from "./OrderFormMulti.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderFormMulti.vue?vue&type=script&setup=true&lang=ts"

import "./OrderFormMulti.vue?vue&type=style&index=0&id=709e764c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-709e764c"]])

export default __exports__